<div
class="cardlink-featured-offer-block shadow-sm rounded cursor-pointer"
[routerLink]="'/offerdetail/' + featuredOffer.OfferId"
>
<div class="d-flex align-items-center justify-content-center flex-column featured-offer-bg-img">
  <img class="featureoffer-bg-image" [src]="featuredOffer.ImageUrl | contentImage: '6'" />
  <div class="main-offer-image-block">
    <div class="offer-item feature-offer-image">
      <div class="offer-item-image">
        <img class="offer-item-companyimage" [src]="featuredOffer.CompanyImageUrl | contentImage: '6'" />
      </div>
    </div>
  </div>
</div>
<div class="feature-content-block">
  <p class="feature-offer-name-title">{{ featuredOffer.Content | currentLanguageContent: currentLcid:'Name' }}</p>
  <p class="feature-offer-name-description font-size-14 mb-0">
    {{ featuredOffer.Content | currentLanguageContent: currentLcid:'description' | shortText: 25:true }}
  </p>
</div>
<div class="btn-online-instore-block pb-2 justify-content-center">
  <div *ngIf="featuredOffer.OfferLocations == 1 || featuredOffer.OfferLocations == 3" class="chip btn-online">
    {{ 'fgbcl.card.linking.succes.offer.online.button.title' | translate }}
  </div>
  <div *ngIf="featuredOffer.OfferLocations == 2 || featuredOffer.OfferLocations == 3" class="chip btn-instore">
    {{ 'fgbcl.card.linking.succes.offer.instore.button.title' | translate }}
  </div>
</div>
</div>